// Update Regularusers Group
export const UPDATE_REGULARUSERS_GROUP_REQUEST = 'UPDATE_REGULARUSERS_GROUP_REQUEST';
export const UPDATE_REGULARUSERS_GROUP_DONE = 'UPDATE_REGULARUSERS_GROUP_DONE';
export const UPDATE_REGULARUSERS_GROUP_FAILED = 'UPDATE_REGULARUSERS_GROUP_FAILED';